import React, { useCallback, useEffect, useRef, useState } from 'react'
import { get, isArray } from 'lodash'
import { clearInput } from 'tennders-stracture/libs/utils'
import ClearInputButton from '../ClearInputButton'

const TextArea = (props) => {
  const {
    onSet,
    disabled,
    readOnly,
    className,
    value,
    error,
    name,
    ...rest
  } = props
  const [inputValue, setInputValue] = useState([])
  const [cursor, setCursor] = useState(null)
  const ref = useRef(null)

  const onFormChange = (e) => {
    if (readOnly || disabled) {
      return
    }
    if (onSet) {
      setCursor(e.target.selectionStart)
      onSet(e.target?.value)
      setInputValue(e.target?.value)
    }
  }

  const handleClearInput = useCallback(() => {
    onSet('')
    setInputValue([])
  }, [])

  useEffect(() => {
    if (value) {
      setInputValue([value])
    } else {
      setInputValue([])
    }
  }, [value])

  useEffect(() => {
    const input = ref.current
    if (input) {
      input.setSelectionRange(cursor, cursor)
    }
  }, [ref, cursor, inputValue])

  return (
    <div className="pos-rel">
      <textarea
        ref={ref}
        name={name}
        disabled={!!disabled}
        readOnly={!!readOnly}
        className={`${className || 'form-textarea'}${error ? ' error' : ''}${disabled ? ' disabled' : ''}`}
        onChange={onFormChange}
        {...rest}
        data-value={get(inputValue, '0') || ''}
        value={get(inputValue, '0') || ''}
      >
        {get(inputValue, '0') || ''}
      </textarea>
      <ClearInputButton
        clearInput={handleClearInput}
        showClearInput={get(inputValue, 'length') > 0 && !(!!disabled || !!readOnly)}
      />
    </div>
  )
}

export default React.memo(TextArea)
